class KbMegaMenu extends HTMLElement {
  connectedCallback() {
    this.links = this.querySelectorAll('[data-kb-need]');
    this.boundActivate = (event) => {
      const target = event.currentTarget;
      if (!(target instanceof HTMLElement)) return;
      const id = target.dataset.kbNeed;
      if (id) this.activate(id);
    };

    this.links.forEach((link) => {
      link.addEventListener('pointerenter', this.boundActivate);
      link.addEventListener('focus', this.boundActivate);
    });
  }

  disconnectedCallback() {
    this.links?.forEach((link) => {
      link.removeEventListener('pointerenter', this.boundActivate);
      link.removeEventListener('focus', this.boundActivate);
    });
  }

  /**
   * @param {string} id
   */
  activate(id) {
    this.dataset.activeNeed = id;

    this.links.forEach((link) => {
      const on = link.dataset.kbNeed === id;
      link.classList.toggle('is-active', on);
      if (on) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    this.querySelectorAll('[data-kb-panel]').forEach((panel) => {
      const on = panel instanceof HTMLElement && panel.dataset.kbPanel === id;
      panel.hidden = !on;
      panel.classList.toggle('is-active', on);
    });
  }
}

if (!customElements.get('kb-mega-menu')) {
  customElements.define('kb-mega-menu', KbMegaMenu);
}

const KB_HEADER_DRAWER_MQ = '(max-width: 989px)';

function kbScrollInstantly(element, top) {
  if (!(element instanceof Element)) return;
  const previous = element.style.scrollBehavior;
  element.style.scrollBehavior = 'auto';
  element.scrollTop = top;
  element.style.scrollBehavior = previous;
}

function kbRestoreDesktopScroll() {
  document.querySelectorAll('header-drawer.kb-drawer details[open]').forEach((details) => {
    details.open = false;
    details.classList.remove('menu-open');
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  });

  const drawer = document.querySelector('header-drawer.kb-drawer');
  if (drawer && typeof drawer.close === 'function') {
    drawer.close();
  }

  document.documentElement.removeAttribute('scroll-lock');
  document.body.style.removeProperty('overflow');

  const root = document.scrollingElement || document.documentElement;
  const pageWrapper = document.querySelector('.page-wrapper');
  if (!pageWrapper) return;

  kbScrollInstantly(pageWrapper, root.scrollTop || pageWrapper.scrollTop);
  kbScrollInstantly(root, 0);
}

function kbSyncHeaderMenuStyle() {
  const header = document.querySelector('#header-component.kb-header');
  if (!(header instanceof HTMLElement)) return;

  const isMobileNav = window.matchMedia(KB_HEADER_DRAWER_MQ).matches;

  if (isMobileNav) {
    if (header.dataset.menuStyle !== 'drawer') {
      header.dataset.menuStyle = 'drawer';
    }
    return;
  }

  kbRestoreDesktopScroll();
}

function kbInitMobileDrawerToggle() {
  const drawer = document.querySelector('header-drawer.kb-drawer');
  const details = document.querySelector('#Details-menu-drawer-container');
  const summary = details?.querySelector(':scope > summary');

  if (!(drawer instanceof HTMLElement) || !(details instanceof HTMLDetailsElement) || !(summary instanceof HTMLElement)) {
    return;
  }

  if (typeof drawer.toggle !== 'function' || drawer.dataset.kbToggleBound === 'true') return;

  const originalToggle = drawer.toggle.bind(drawer);
  drawer.dataset.kbToggleBound = 'true';

  drawer.toggle = () => {
    if (!window.matchMedia(KB_HEADER_DRAWER_MQ).matches) {
      return originalToggle();
    }

    if (details.classList.contains('menu-open') || details.open) {
      return drawer.close();
    }

    details.open = true;
    details.offsetHeight;
    return drawer.open();
  };

  summary.addEventListener(
    'click',
    (event) => {
      if (!window.matchMedia(KB_HEADER_DRAWER_MQ).matches) return;
      event.preventDefault();
    },
    true
  );
}

function kbInitHeaderMenuStyle() {
  const header = document.querySelector('#header-component.kb-header');
  if (!(header instanceof HTMLElement)) return;

  kbSyncHeaderMenuStyle();
  if (customElements.get('header-drawer')) {
    kbInitMobileDrawerToggle();
  } else {
    customElements.whenDefined('header-drawer').then(kbInitMobileDrawerToggle);
  }
  window.matchMedia(KB_HEADER_DRAWER_MQ).addEventListener('change', kbSyncHeaderMenuStyle);

  const observer = new MutationObserver(() => {
    if (window.matchMedia(KB_HEADER_DRAWER_MQ).matches) {
      kbSyncHeaderMenuStyle();
    }
  });
  observer.observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', kbInitHeaderMenuStyle);
} else {
  kbInitHeaderMenuStyle();
}
